// extracted by mini-css-extract-plugin
export default {"accounts":"LinkedAccountsBlock_accounts__IRDj0"};